module.exports = __webpack_public_path__ + "img/filter.f164db29.svg";